import React from 'react';
import { HourPatternCell } from '../cell-components/HourPatternCell';
import { WeekPatternCell } from '../cell-components/WeekPatternCell';

export const live_ranges_columns = [
  {
    title: 'Employee name',
    dataIndex: 'employeeName',
    key: 'doctor',
    width: 250,
  },
  {
    title: 'Employee id',
    dataIndex: 'employeeId',
    key: 'id',
    width: 140,
  },
  {
    title: 'Office number',
    dataIndex: 'office',
    key: 'office',
    width: 140,
  },
  {
    title: 'Office name',
    dataIndex: 'officeName',
    key: 'officeName',
    width: 140,
  },
  {
    title: 'Date Range',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 160,
  },
  {
    title: 'Date Of Week',
    dataIndex: 'dayOfWeek',
    key: 'dayOfWeek',
    width: 160,
  },
  {
    title: 'Office HOO',
    dataIndex: 'officeHoursOfOperation',
    key: 'officeHours',
    width: 150,
    render: (pattern) => <HourPatternCell pattern={pattern} />,
  },
  {
    title: 'Template Name',
    dataIndex: 'templateName',
    key: 'templateName',
    width: 140,
  },
  {
    ellipsis: true,
  }, // empty column, workaround to have column width fixed
];
